import React, { useState } from 'react'
import { Box, Button, Grid2 as Grid, Typography, useTheme } from '@mui/material'
import ProfileCard from '../../customers/basicDetails/ProfileCard'
import BasicDetailsCard from '../../customers/basicDetails/BasicDetailsCard'
import Colors from '../../../utils/colors.json'
import useCustomStyles from '../../../hooks/CustomStylesHook'
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye'

const styles = (theme: any) => ({
  fieldLabel: {
    fontSize: theme.typography.pxToRem(13),
    color: Colors.TEXT_COLOR_TERTIARY,
    fontWeight: 400,
  },
  fieldValue: {
    fontWeight: 400,
    color: Colors.TEXT_COLOR_SECONDARY,
    fontSize: theme.typography.pxToRem(14),
  },
  iconBtn: {
    fontSize: '12px',
    textDecoration: 'underline',
    textTransform: 'capitalize',
  },
  section: {
    width: '100%',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1.2),
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body2.fontSize,
  },
  valueBox: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    fontSize: '15px',
    fontWeight: theme.typography.fontWeightBold,
  },
})

const BasicDetails = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const [readMore, setReadMore] = useState(false)

  const ProfileSection = () => {
    return (
      <>
        {readMore && (
          <>
            <Box className={classes?.section}>
              <Typography className={classes?.label}>Advance Piad</Typography>
              <div className={classes?.valueBox}>₹{1000}</div>
            </Box>
            <Box className={classes?.section}>
              <Typography className={classes?.label}>Premium Piad</Typography>
              <div className={classes?.valueBox}>₹{12000}</div>
            </Box>
            <Box className={classes?.section}>
              <Typography className={classes?.label}>Sum Insured</Typography>
              <div className={classes?.valueBox}>₹{500000}</div>
            </Box>
          </>
        )}
      </>
    )
  }

  const BasicDetailsSection = () => {
    return (
      <>
        {readMore && (
          <Grid container mt={7} spacing={2}>
            <Grid size={{ xs: 6, sm: 6 }}>
              <Typography className={classes?.fieldLabel}>
                Payment Status
              </Typography>
              <Typography className={classes?.fieldValue}>
                KIMS Hospital
              </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6 }}>
              <Typography className={classes?.fieldLabel}>
                Home Visit{' '}
                <span className={classes?.fieldValue}>
                  (16/2/24) <span>Completed</span>
                </span>
              </Typography>
              <Typography className={classes?.fieldLabel}>
                Physical Assessment:{' '}
                <span className={classes?.fieldValue}>IN-AS-9-3-XXXXX</span>
              </Typography>
              <Typography className={classes?.fieldLabel}>
                Lab Tests:{' '}
                <span className={classes?.fieldValue}>IN-DG-9-3-XXXXX</span>
              </Typography>
              <Typography className={classes?.fieldLabel}>
                Location:{' '}
                <span className={classes?.fieldValue}>Amalapuram</span>
              </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6 }}>
              <Typography className={classes?.fieldLabel}>
                Assigned To
              </Typography>
              <Typography className={classes?.fieldValue}>
                Suneel(EMP123)
              </Typography>
              <Typography className={classes?.fieldValue}>
                P.no.- 8989632662
              </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6 }}>
              <Typography className={classes?.fieldLabel}>
                Customer Address
              </Typography>
              <Typography className={classes?.fieldValue}>
                Hno.289, Sai sindhu residency, Ambedkar Nagar Amlapuram, 42020{' '}
              </Typography>
            </Grid>
          </Grid>
        )}
        <Box
          display={'flex'}
          justifyContent={'end'}
          alignItems={'center'}
          width={'100%'}
        >
          <Button
            color='primary'
            className={classes?.iconBtn}
            startIcon={<RemoveRedEyeIcon />}
            onClick={() => setReadMore(!readMore)}
          >
            {readMore ? 'View Less' : 'View More'}
          </Button>
        </Box>
      </>
    )
  }

  return (
    <Grid container direction={'column'} spacing={1.5}>
      <Grid></Grid>
      <Grid>
        <Grid container direction={'row'} spacing={1.5}>
          <Grid size={{ xs: 12, sm: 12, lg: 4, md: 4, xl: 4 }}>
            <ProfileCard
              actions={false}
              isMrnAba={true}
              section={<ProfileSection />}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, lg: 8, md: 8, xl: 8 }}>
            <BasicDetailsCard section={<BasicDetailsSection />} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default BasicDetails
